// extracted by mini-css-extract-plugin
export default {"label":"TabletFilterLabel_label__pxUfU","smallLabel":"TabletFilterLabel_smallLabel__O0DA6"};